import React from 'react';
import { motion } from 'framer-motion';
import MlIcon2 from '../../images/family-overview/ml-icon-2.png';
import IsIcon1 from '../../images/family-overview/is-icon-1.png';
import IsIcon2 from '../../images/family-overview/is-icon-2.png';
import IsIcon3 from '../../images/family-overview/is-icon-3.png';
import IsIcon4 from '../../images/family-overview/is-icon-4.png';
import IsIcon5 from '../../images/family-overview/is-icon-5.png';
import IsIcon6 from '../../images/family-overview/is-icon-6.png';
import IsIcon7 from '../../images/family-overview/is-icon-7.png';
import MlIcon1 from '../../images/family-overview/ml-icon-1.png';
import EsIcon2 from '../../images/family-overview/es-icon-2.png';
import EsIcon1 from '../../images/family-overview/es-icon-1.png';

export default function Features() {
  const container1 = {
    /* parent animation */
    hidden: {},
    show: {
      transition: {
        delayChildren: 1.6,
        staggerChildren: 0.4,
      },
    },
  };
  const container2 = {
    /* parent animation */
    hidden: {},
    show: {
      transition: {
        delayChildren: 5.2,
        staggerChildren: 0.4,
      },
    },
  };
  const container3 = {
    /* parent animation */
    hidden: {},
    show: {
      transition: {
        delayChildren: 6.8,
        staggerChildren: 0.4,
      },
    },
  };

  const item = {
    /* child animation */
    hidden: { opacity: 0, y: -10 },
    show: { opacity: 1, y: 0, transition: { duration: 1.2 } },
  };
  return (
    <div id="features" className="family-overview-subpage">
      <div id="improve-speech-block">
        <motion.div
          className="heading"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          Improve speech understanding
        </motion.div>
        <motion.div
          className="features-block"
          variants={container1}
          initial="hidden"
          animate="show"
        >
          <motion.div className="block" variants={item}>
            <img src={IsIcon1} />
            <div className="label">MoreSound Intelligence™</div>
            <div className="desc">
              Access to all relevant sounds in a clear, complete and balanced
              sound scene
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={IsIcon2} /> <div className="label">Virtual Outer Ear</div>
            <div className="desc">
              Three realistic models of the ear pinna to provide better spatial
              balance
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={IsIcon3} /> <div className="label">Spatial Sound™</div>
            <div className="desc">
              Improves ability to locate the most interesting sounds
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={IsIcon4} />
            <div className="label">MoreSound Amplifier™</div>
            <div className="desc">
              Rapid high-resolution amplification that follows changes in the
              sound scene
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={IsIcon5} /> <div className="label">Sound Enhancer</div>
            <div className="desc">
              Dynamic gain primarily for speech, given in complex environments
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={IsIcon6} />{' '}
            <div className="label">Soft Speech Booster</div>
            <div className="desc">
              Improves soft speech understanding without turning up the volume
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={IsIcon7} />
            <div className="label">MoreSound Optimizer™</div>
            <div className="desc">
              Optimal gain and open fittings, without feedback risk
            </div>
          </motion.div>
        </motion.div>
      </div>

      <div id="enhance-sound-block">
        <motion.div
          className="heading"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          Enhance sound quality
        </motion.div>
        <motion.div
          className="features-block"
          variants={container2}
          initial="hidden"
          animate="show"
        >
          <motion.div className="block" variants={item}>
            <img src={EsIcon1} />
            <div className="label">Speech Rescue™</div>
            <div className="desc">Makes high frequency sounds more audible</div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={EsIcon2} />
            <div className="label">Clear Dynamics</div>
            <div className="desc">
              Better sound quality with less distortion in loud environments
            </div>
          </motion.div>
        </motion.div>
      </div>

      <div id="maximize-listening-block">
        <motion.div
          className="heading"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.9 }}
        >
          Maximize listening comfort and personalization
        </motion.div>
        <motion.div
          className="features-block"
          variants={container3}
          initial="hidden"
          animate="show"
        >
          <motion.div className="block" variants={item}>
            <img src={MlIcon1} />
            <div className="label">Wind Noise Management</div>
            <div className="desc">
              Improves access to speech in situations with wind noise
            </div>
          </motion.div>
          <motion.div className="block" variants={item}>
            <img src={MlIcon2} />
            <div className="label">Tinnitus SoundSupport™</div>
            <div className="desc">Relief sounds for tinnitus clients</div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
